import { useContext } from 'react'
import { AddBeneficiaryContext } from 'contexts/addBeneficiaryContext'

export const useAddBeneficiaryContext = () => {
  return useContext(AddBeneficiaryContext)
}
